<div class="zoom-container" (click)="viewZoomDetails(meeting?.slug)">
  <div class="card">

    <!-- LEFT -->
    <div class="card-left">

      <!-- Premium badge -->
      <span class="premium-tag pts" *ngIf="meeting?.is_premium == 1">P</span>

      <!-- Thumbnail -->
      <img class="zoom_card_meeting_thumbnail" [src]="meeting?.thumbnail || 'assets/default.jpg'" alt="event" />

      <!-- Live / status -->
      <div class="live" *ngIf="meeting?.status === 'Upcoming'">
        Live <span>LIVE</span>
      </div>

    </div>

    <!-- RIGHT -->
    <div class="card-right">
 
      <p class="desc" [innerHTML]="meeting?.title"></p>
      

      <!-- Date -->
      <p class="date">
        {{ meeting?.date }}
      </p>

      <!-- Speaker / Tag -->
      <p class="tag">
        {{ meeting?.speaker }}
      </p>

      <!-- Join button -->

      <div class="play-info" *ngIf="meeting?.status">
        <ng-container>
          <a class="play-btn wave"
            (click)="handleMeetingAction(meeting, $event)"> 
             {{meeting?.buttonLabel}}
          </a>
        </ng-container>
      </div>

     


      <!-- <button 
        class="join-btn"
        *ngIf="meeting?.status == 'ongoing'"
        (click)="joinMeeting(meeting?.id, $event)">
        Join
      </button>
      <button 
        class="join-btn"
        *ngIf="meeting?.status == 'Upcoming' && meeting?.zoom_type == 'NORMAL'"
        (click)="disabledBtn(meeting, $event)"
        >
        Upcoming
      </button>
      <button 
        class="join-btn"
        *ngIf="meeting?.status == 'Upcoming' && meeting?.zoom_type == 'EVENT'"
        (click)="joinMeeting(meeting?.id, $event)"
        >
        Register
      </button>
      <button 
        class="join-btn"
        *ngIf="meeting?.status == 'Ended'"
        (click)="watchRecording(meeting, $event)"
        >
        Watch Recording
      </button> -->

    </div>

  </div>
</div>